module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-4-f0c8b2b0106ae2b9701b6120bb12b974.jpg";